import {useApiQuery} from 'src/hooks/useApiQuery';
import type {DashboardListResponse} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';


export function useDashboardList({
  page = 1,
  pageSize = 10,
  enabled = true,
}: {page?: number; pageSize?: number; enabled?: boolean} = {}) {
  const offset = (page - 1) * pageSize;
  return useApiQuery<DashboardListResponse>(
    {
      pathname: `${BASE}/dashboards`,
      query: {limit: String(pageSize), offset: String(offset)},
    },
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-dashboard-list', page, pageSize],
        staleTime: 30 * 1000,
        gcTime: 60 * 1000,
        enabled,
      },
    },
  );
}
